import { brandclub_colors } from "@brandclub/common-ui";
import Radio, { RadioProps } from "@mui/material/Radio";
import { styled } from "@mui/material/styles";
import {
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "../AppNavigation/constants";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 22,
  height: 22,
  backgroundColor: "#fff",
  border: `1.4px solid ${theme.vars.palette.text.primary}`,
  display: "inline-block",
  position: "relative",
  verticalAlign: "middle",

  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    width: 15,
    height: 15,
  },
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    width: 15,
    height: 15,
  },
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: brandclub_colors.white,
  border: `1.4px solid ${theme.vars.palette.text.primary}`,
  "&::before": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 13,
    height: 13,
    borderRadius: "50%",
    backgroundColor: theme.vars.palette.text.primary,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      width: 8,
      height: 8,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      width: 8,
      height: 8,
    },
  },
  "input:hover ~ &": {},
}));

// Inspired by blueprintjs
const StoreRadio = (props: RadioProps) => {
  return (
    <Radio
      disableRipple
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      sx={{ padding: 0 }}
      {...props}
    />
  );
};

export default StoreRadio;
